import { ApiInstance } from "utils/Api";

import type { LeadsCarsFilter } from "modules/LeadsDashboard/queryKeys";

export const exportLeadsCars = async (carsFilters: LeadsCarsFilter) => {
  await ApiInstance.post("/leads/export/cars/enqueue", carsFilters);
};
